<div class="modal is-active" [formGroup]="Form">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Access Control</p>
    </header>
    <section class="modal-card-body"style="min-width: 800px;">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Access Type</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select formControlName="ClassName" name="ClassName" (change)="ClassChanged()">
                  <option value="ControlledAreaAccessMethodPublic">Public Access</option>
                  <option value="ControlledAreaAccessMethodWhiteList">Access List Only</option>
                </select>
              </div>
              <app-validator [For]="this.Form.get('ClassName')"></app-validator>
            </div>
          </div>
        </div>
      </div>
      @if (GetClassName() == 'ControlledAreaAccessMethodWhiteList') {
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Access List</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                @if (AccessLists != null) {
                  <div class="select is-fullwidth">
                    <select formControlName="PlateAccessListId" name="PlateAccessListId" (change)="AccessListChanged()">
                      @for (a of AccessLists; track a) {
                        <option [ngValue]="a.Id">{{a.Name}}</option>
                      }
                    </select>
                  </div>
                }
                @if (AccessLists == null) {
                  <span>
                    Loading...
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Charge Strategy</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select formControlName="ChargeStrategy" name="ChargeStrategy" (change)="ChargeStrategyChanged()">
                  <option value="None">None</option>
                  <option value="Hold">Hold on Entry</option>
                  <option value="PostPay">Pay at Exit</option>
                  <option value="PrePay">Pay at Entry</option>
                </select>
              </div>
              <app-validator [For]="this.Form.get('ChargeStrategy')"></app-validator>
            </div>
          </div>
        </div>
      </div>

      @if (ShowRateSet()) {
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Rate Set</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                @if (RateSets != null) {
                  <div class="select is-fullwidth">
                    <select formControlName="RateSetId" name="RateSetId" (change)="RateSetChanged()">
                      @for (a of RateSets; track a) {
                        <option [ngValue]="a.Id">{{a.Name}}</option>
                      }
                    </select>
                  </div>
                }
                <app-validator [For]="this.Form.get('RateSetId')"></app-validator>
                @if (RateSets == null) {
                  <span>
                    Loading...
                  </span>
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (GetChargeStrategy() === 'Hold') {
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Hold Amount</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="number" step="0.01" formControlName="HoldChargeAmount" (change)="UpdateChargeStrategyDescription()">
                <app-validator [For]="this.Form.get('HoldChargeAmount')"></app-validator>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Target Selection UI -->
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Applies To</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select formControlName="TargetParkingLotId" (change)="onLotChange()">
                  <option [ngValue]="null">All Parking Lots</option>
                  @for (lot of ParkingLots; track lot) {
                    <option [ngValue]="lot.Id">{{lot.Name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (selectedLot) {
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Gate</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="TargetGateId" (change)="onGateChange()">
                    <option [ngValue]="null">All Gates</option>
                    @for (level of selectedLot.Levels; track level) {
                      <option disabled>{{level.Name}}</option>
                      @for (gate of level.Gates; track gate) {
                        <option [ngValue]="gate.Id">{{level.Name}} - {{gate.Name}}</option>
                      }
                    }
                  </select>
                </div>
                @if (!selectedLot.Levels) {
                  <span class="help">Loading gates...</span>
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (selectedGate) {
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Lane</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="TargetLaneId">
                    <option [ngValue]="null">All Lanes</option>
                    @for (lane of selectedGate.Lanes; track lane) {
                      <option [ngValue]="lane.Id">{{lane.Name}}</option>
                    }
                  </select>
                </div>
                @if (!selectedGate.Lanes) {
                  <span class="help">Loading lanes...</span>
                }
              </div>
            </div>
          </div>
        </div>
      }

    </section>
    <footer class="modal-card-foot">
      <button class="button is-background-white" (click)="close()"><span class="icon"><i class="fas fa-times"></i></span><span>Cancel</span></button>
      @if (NewMethod) {
        <button class="button is-primary" (click)="confirm()"><span class="icon"><i class="fas fa-plus"></i></span><span>Add</span></button>
      }
      @if (!NewMethod) {
        <button class="button is-primary" (click)="confirm()"><span class="icon"><i class="fas fa-check"></i></span><span>Update</span></button>
      }
    </footer>
  </div>
</div>